module.exports = __webpack_public_path__ + "img/iys_illustrasyon_01.6b392a2c.svg";